
import {Form, Webcam, XHRUpload} from "uppy"
import Uppy from '@uppy/core'
import React from 'react'
import {Dashboard, DashboardModal} from '@uppy/react'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import {h} from 'preact'
import {Button} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
export default class MusicUploadButton extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            modalOpen: false,

        }

        this.uppy = new Uppy()
            .use(XHRUpload, { endpoint: '/api/songs/upload' })
            .use(Webcam, { modes: ['audio-only'] })
            .on('complete', (result) => {
            console.log('successful files:', result.successful)
            console.log('failed files:', result.failed)
            })
        this.handleOpen = this.handleOpen.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }


    componentWillUnmount() {

        this.uppy.close({ reason: 'unmount' })
    }




    handleOpen () {
        this.setState({
            modalOpen: true,
        })
    }

    handleClose () {
        this.setState({
            modalOpen: false,
        })
    }

    render () {
        return (
            <div style={{background:"rgb(32, 32, 48) ",height:document.documentElement.clientHeight}}>
                    


            <div style={{display:"flex",justifyContent:"center",height:""}}>
                <Button style={{marginTop:'10%'}}  variant={"outlined"} onClick={this.handleOpen}>Upload Your unique music</Button>
                <DashboardModal

                    uppy={this.uppy
                        }
                    closeModalOnClickOutside
                    open={this.state.modalOpen}
                    onRequestClose={this.handleClose}
                    proudlyDisplayPoweredByUppy
                    plugins={['Webcam']}
                    trigger={"#select files"}
                    theme={"auto"}
                    // metaFields={[
                    //     {id: 'name', name: 'Name',
                    //         render({value, onChange, required, form},h){
                    //             return h('input',
                    //                 { type: 'checkbox',
                    //                     required,
                    //                     form,
                    //                     onChange: (ev) => onChange(ev.target.checked ? 'on' : ''),
                    //                     defaultChecked: value === 'on' });
                    //         },
                    //         placeholder:"name of your work"},
                    //
                    // ]}
                    note={'Music only, 2–3 files, up to 20 MB.' +
                        "for better experience, recommend using Chrome"}
                />
            </div>
            </div>
        )
    }
}

// export default  function MusicUploadButton(props){
//     const [upload,setUpload] = React.useState();
//     const uppy = React.useMemo(()=>{
//         return new Uppy()
//             .use(XHRUpload, { endpoint: '/api/songs/upload' })
//             .use(Webcam, { modes: ['audio-only'] })
//             .on('complete', (result) => {
//                 console.log('successful files:', result.successful)
//                 console.log('failed files:', result.failed)
//             })
//
//     },[])
//     React.useEffect(()=>{
//         return ()=> uppy.close({reason:'unmount'})
//     },[uppy])
//
//     return (
//     <div>
//         {/*<Dialog open={props.open} onClose={props.handleClose}>*/}
//         {/*    <DialogTitle>Sign in to Lepton</DialogTitle>*/}
//             {/*<DialogContent>*/}
//             <Dashboard
//                 uppy={uppy}
//                 // closeModalOnClickOutside
//                 plugins={['Webcam']}
//                 theme={'auto'}
//                 fileManagerSelectionType={'audio'}
//                 inline
//                 />
//             {/*</DialogContent>*/}
//
//         {/*</Dialog>*/}
// </div>
//
//     )
// }